export default __webpack_public_path__ + "static/media/Group38288.bc9b00eb.png";